var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"winnerBoardModal","hide-footer":"","hide-header":"","body-class":"p-0"}},[_c('div',{staticClass:"modal-card card",staticStyle:{"border":"none","min-height":"600px"}},[_c('WinnerBoardHeader'),(_vm.initialized)?_c('WinnerBoardWinner'):_vm._e(),(_vm.initialized)?_c('WinnerBoardPastWinners'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }